<template>
  <div>
    <!-- ========== 优化后的筛选区域 ========== -->
    <div class="filter-container">
      <div class="filter-row">
        <div class="filter-item">
          <label class="filter-label">报案人查询：</label>
          <el-input 
            v-model="reportName" 
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
        <div class="filter-item">
          <label class="filter-label">出险人查询：</label>
          <el-input 
            v-model="victimName" 
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
        <div class="filter-item">
          <label class="filter-label">保单号查询：</label>
          <el-input 
            v-model="insurancePolicyNo" 
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
        <div class="filter-item">
          <label class="filter-label">证件号查询：</label>
          <el-input 
            v-model="idNo" 
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
      </div>
      <div class="button-row">
        <div class="button-group">
          <el-button 
            type="primary" 
            @click="filt()" 
            class="filter-btn">
            查询
          </el-button>
          <el-button 
            type="primary" 
            @click="Reset()" 
            class="reset-btn">
            重置
          </el-button>
        </div>
      </div>
    </div>
    <!-- ========== 优化后的筛选区域结束 ========== -->
    
    <div class="form_box">
      <el-table empty-text="暂无数据" :data="tableData" border>
        <!-- <el-table-column prop="number" label="序号" min-width="50%">
        </el-table-column> -->
        <el-table-column prop="caseNo" label="案件编号" min-width="80">
        </el-table-column>
        <el-table-column prop="addr" label="发生地点" min-width="100%">
        </el-table-column>
        <el-table-column prop="victimName" label="出险人" min-width="50%">
        </el-table-column>
        <el-table-column prop="reportUser" label="报案人" min-width="50%">
        </el-table-column>
        
        <el-table-column prop="reporterContact" label="用户手机号" min-width="70%">
        </el-table-column>
        <el-table-column prop="idNo" label="证件信息" min-width="70%">
        </el-table-column>
        <el-table-column prop="gender" label="性别" min-width="40%">
        </el-table-column>
        <el-table-column prop="incidentTs" label="出险时间" min-width="90%">
        </el-table-column>
        <el-table-column prop="accidentType" label="服务类型" min-width="90%">
        </el-table-column>
        <el-table-column prop="insurancePolicyNo" label="保单号" min-width="90%">
        </el-table-column>
        <!-- <el-table-column prop="par" label="用户保险详情" min-width="70%">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-show="scope.row.isshow" @click="toUrl(scope.row.insuranceUrl)">保险详情</el-button>
            <el-button type="text" size="small" v-show="!scope.row.isshow">无</el-button>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="phase" label="当前进度" min-width="80%"> -->
           
        <!-- </el-table-column> -->
         <!-- <el-table-column prop="subRegulatorIdname" label="保险公司子公司" min-width="80%"> </el-table-column>
        <el-table-column prop="el" label="其他" min-width="90%">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="dialogVisible=true;closeId=scope.row.caseId">关闭当前案件</el-button>
          </template>
        </el-table-column> -->
        <el-table-column prop="op" label="操作" min-width="90%">
          <template slot-scope="scope">
          
            <el-button type="text" size="small" @click="topar(scope.row.id,scope.row)">创建案件</el-button>
              <el-button type="text" size="small" @click="Viewactions(scope.row)">查看操作</el-button>
            <el-button type="text" size="small" @click="del1(scope.row.id)">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <span>确认关闭？</span>
        <textarea placeholder="请输入关闭原因" v-model="closeTxt" class="closeTxt"></textarea>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false;closeCase(closeId)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 弹窗 -->
    <el-dialog title="删除" center :visible.sync="dialogFormVisible" width="800px">
      <div class="popBox">
        <p style="margin-bottom: 15px">确认删除？</p>
        
      </div>
    	<div slot="footer" class="dialog-footer">
    		<el-button @click="dialogFormVisible = false">取 消</el-button>
    		<el-button type="primary" @click="del()">确 定</el-button>
    	</div>
    </el-dialog>
    <!-- 添加 -->
    <!-- <el-dialog title="修改协调人" :visible.sync="showcooperaterDialogVisible" center top="1vh" width="1000px" @close="toggleSelection()">
       <span class="contactAddStyle" @click="addContacterDialogVisible=true"></span>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="修改协调人" name="second">
          <el-table empty-text="暂无数据" :data="cooperaterData" class="mgt15" border @selection-change="handleSelectionChange" ref="multipleTable">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="name" label="姓名" min-width="30"></el-table-column>
            <el-table-column prop="mobileNo" label="手机号" min-width="30"></el-table-column>
            <el-table-column prop="nationalId" label="证件号码" min-width="30"></el-table-column>
          </el-table>
          <div style="text-align: center;margin-top: 10px;">
            <el-button type="primary" @click='diffDomestic()'>确定</el-button>
            <el-button @click='toggleSelection();showcooperaterDialogVisible=false'>取消</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="非公司隶属的协调人" name="first">
          <el-table empty-text="暂无数据" :data="cooperaterData1" class="mgt15" border @selection-change="handleSelectionChange1" ref="multipleTable1">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="name" label="姓名" min-width="30"></el-table-column>
            <el-table-column prop="mobileNo" label="手机号" min-width="30"></el-table-column>
          </el-table>
          <div style="text-align: center;margin-top: 10px;">
            <el-button type="primary" @click="diffNormalUser()">确定</el-button>
            <el-button @click='toggleSelection1();showcooperaterDialogVisible=false'>取消</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog> -->
   

    <!-- 添加新注册的协调人 -->
    <el-dialog title="添加新协调人" center :visible.sync="addContacterDialogVisible" width="500px">
    	<div>
        <div id="">
          姓&nbsp;&nbsp;&nbsp;&nbsp;名：<el-input v-model="victimName" placeholder="请输入姓名" style='width: 300px;'></el-input>
        </div>
        <div style="margin-top: 10px;">
          手机号：<el-input v-model="nationalMobile" placeholder="请输入姓名" style='width: 300px;'></el-input>
        </div>
      </div>
    	<div slot="footer" class="dialog-footer">
    		<el-button @click="addContacterDialogVisible = false">取 消</el-button>
    		<el-button type="primary" @click="newDJXid()">确 定</el-button>
    	</div>
    </el-dialog>
  </div>
</template>

<script>
  import qs from "qs";
  import { casedel_case_info,caselist_case_info,listSubRegulators,userlist_regulator,getfinishSureCase,listSubUser,diffDomestic,listDomestic,removeDomestic,closeOrdinaryCase ,listNormalUser,diffNormalUser,creatBasic,joinCoord } from '@/views/axios/api.js'
  import constants from '@/util/constants.js';
  export default {
    data() {
      return {
        delid:'',
        accidentTypes: ["疏通马桶服务", "开锁服务","油烟机清洗","油烟机拆洗","保洁2小时","保洁4小时","擦玻璃小户型（100平米下）","擦玻璃大户型（100-150平米）"],
         accidentType:'',
        reportUser:'',
        st_time:'',
        en_time:'',
         subRegulatorId:'',
        companies1:[],
        companies:[],
        insuranceCompanyId:'',
        closeId:"",
         closeTxt:'',
        obj:[],
        victimList:[],
        dialogVisible:false,
        tableData: [],
        token: JSON.parse(window.localStorage.getItem("data")).data,
        dialogFormVisible:false,
        totalFee:'',
        rescueFee:'',
        medicFee:'',
        otherFee:0,
        caseId:'',
        userType:JSON.parse(window.localStorage.getItem("insti")).type,
        showcooperaterDialogVisible: false,//添加
        cooperaterData:[],//所有联系人
        cooperaterData1:[],//所有联系人
        cooperaterDataList:[],//当前案件未修改之前的记录
        cooperaterDataListCheck:[],//当前案件修改之后
        dialogFormVisible1:false,
        statusObj:['在保','无保','在保','旅责险'],
        activeName: 'second',
        tabBtn:true,
        ruserDataListCheck:[],
        addContacterDialogVisible:false,
        victimName:'',
        nationalMobile:'',
        reportName:'',// 报案人
        insurancePolicyNo:'',// 保单号
        idNo:''// 证件号 
      };
      
    },
    methods: {
      Viewactions(row) {
          
            this.$router.push({
            name: "logPage",
            params: {
              token: this.token
            },
            query: {
              typeId:800,
              caseid: row.id,
            }
          });
      },
      del1(id) {
           this.delid = id
           this.dialogFormVisible = true
      },
      del() {
        var obj = {
          caseId:this.delid,
          token:JSON.parse(window.localStorage.getItem("data")).data
        }
       casedel_case_info(obj).then((res)=>{
         if(res) {
               this.$message.success('删除成功')
               this.dialogFormVisible = false
            this.getData()
         }
         
       })
      },
        caseexport() {
        window.location.href=`${SEVSRS}/rescue/case/export_caseManage_List?token=${JSON.parse(window.localStorage.getItem("data")).data}&incidentType=800&caseState=120&caseState=130&caseState=140&caseState=150&caseState=160&caseState=180&startTs=${this.st_time}&endTs=${this.en_time}&regulatorId=${this.insuranceCompanyId}&subRegulatorId=${this.subRegulatorId}&reportUser=${this.reportUser}&accidentType=${this.accidentType}`
      },
         Reset(){
        this.reportName = ''// 报案人
        this.victimName = ''//  出险人
        this.insurancePolicyNo = ''//  保单号
        this.idNo = ''//  证件号 
        this.getData()
      },
       suoshuFun() {
      userlist_regulator({token:JSON.parse(window.localStorage.getItem("data")).data,regulatorId:this.insuranceCompanyId}).then((res)=>{
          this.companies1 = res.data.obj
            console.log(res)
      })
      },
      setTxt(str, status) {
      	if (constants.setTxt(str, status)) {
      		return constants.setTxt(str, status);
      	} else {
      		return str;
      	}
      },
      setTime(str) {
        return constants.time(str)
      },
       handleClick(tab, event) {
         console.log(tab);
      },
   
        topar(id,item) {
          
          if(this.$route.query.typeId == 800) {
             this.$router.push({
                path: 'draftdetails',
                query: {
                  typeId: this.$route.query.typeId,
                  caseId:id
                },
              });
          }else if(this.$route.query.typeId == 600) {
              console.log(item)
              
               this.$router.push({
                path: 'Starenvoydetails',
                query: {
                  typeId: this.$route.query.typeId,
                  caseId:id
                },
                
              });
              
          }else {
            this.$router.push({
                path: 'otherdraftdetails',
                query: {
                  typeId: this.$route.query.typeId,
                  caseId:id
                },
              });
          }
      
        // return
        // let that = this;
        // this.$router.push({
        //   path: "par",
        //   name: "ComPar",
        //   params: {
        //     token: that.token,
        //     obj: that.obj,
        //     victimList: that.victimList,
        //     index
        //   },
        //   query: {
        //     typeId: this.typeId,
        //     caseid: this.obj[index].id,
        //     backto: 0
        //   }
        // });
      },
     
      listSubUser(){
        var data={
          token:this.token,
          start:0,
          count:100,
          all:1
        }
        listSubUser(data)
        .then(res => {
          console.log(res);
          this.cooperaterData=res.data.obj;
        })
        .catch(err => {
          console.log(err);
        })

      },
      handleSelectionChange(val){
        this.cooperaterDataListCheck=val;
      },
      handleSelectionChange1(val){
        this.ruserDataListCheck=val;
      },
      removeDomestic(id){
        var data={
          token:this.token
        }
        removeDomestic(data,id)
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        })
      },
       toUrl(url) {
        window.open(url);
      },
      	filt() {
		this.getData(this.st_time, this.en_time,this.reportUser,this.accidentType,this.insuranceCompanyId,this.subRegulatorId);
		},
		sttime() {
			this.st_time = this.st_time * 1;
			// this.getData(this.st_time, 0);
			// console.log(this.st_time);
		},
		entime() {
			this.en_time = this.en_time * 1;
			// this.getData(0, this.en_time);
		},
      getData(st, et,reportUser,accidentType,insuranceCompanyId,subRegulatorId) {
          userlist_regulator({token:JSON.parse(window.localStorage.getItem("data")).data}).then((res)=>{
          this.companies1 = res.data.obj
            console.log(res)
      })
       listSubRegulators({token:JSON.parse(window.localStorage.getItem("data")).data}).then((res)=>{
         this.companies = res.data.obj
         console.log(res)
       })
       
    //    	this.tableData = [];
		// 	let that = this;
		// 	let n = 0;
		// 	let sex = '';
		// 	let isshow = false;
		// 	let stTime = st || this.st_time;
		// 	let enTime = et || this.en_time;
		// 	let plan = '';
		// 	let list = [];
		// 	let tl = '';
		// if (stTime || enTime || reportUser || accidentType || insuranceCompanyId || subRegulatorId) {
		// 		tl = tl + `&startTs=${stTime}&endTs=${enTime}&reportUser=${this.reportUser}&accidentType=${this.accidentType}&regulatorId=${this.insuranceCompanyId}&subRegulatorId=${this.subRegulatorId}`;
		// 	}

		// 	let nl = 0;

			// fetch(constants.domain + 'rescue/case/list_case_info ',{
			// 	method: 'POST',
			// 	body: `token=${this.token}&typeId=${this.$route.query.typeId}` ,
			// 	mode: 'cors',
			// 	headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
			// } )
			// 	.then(function(res) {
          
      //     // that.tableData = res.data.obj
			// 		console.log(res);
			// 		return res.json();
			// 	})
			// 	.then(function(data) {
      //     // that.tableData = data.obj
      //     console.log(data.obj)
			// 		if (data.obj) {
			// 			data.obj.map((v, i) => {
      //         console.log(i)
			// 				async function getout(state) {
			// 					that.axios
			// 						.post(
			// 							constants.domain + 'rescue/bidding/list_bidding',
			// 							qs.stringify({
			// 								token: that.token,
			// 								caseId: v.obj.id
			// 							})
			// 						)
			// 						.then(res => {
			// 							list = res.data.obj;
                    	
			// 							if (v.victimList[0].obj.insurancePolicyNo && v.victimList[0].obj.insurancePolicyNo != '') {
			// 								isshow = true;
			// 							} else {
			// 								isshow = false;
			// 							}

			// 							var pt = constants.pt2txt2(state);
			// 							var address = '';
			// 							if (v.generalLocation) {
			// 								if (!constants.setTxt(v.generalLocation.addr, 'zh')) {
			// 									address = v.generalLocation.addr;
			// 								} else {
			// 									address = that.languageIndex == 0 ? constants.setTxt(v.generalLocation.addr, 'zh') : constants.setTxt(v.generalLocation.addr, 'en');
			// 								}
			// 							}
			// 							that.tableData.push({
      //                   state: v.obj.caseState,
      //                   caseId: v.obj.id,
      //                   initialCaseId:v.obj.initialCaseId,
      //                   stateText3: v.obj.stateText3 || '无',
      //                   number: i + 1, //序号
      //                   casenumber: v.obj.caseNo, //案件编号
      //                   address, //地址
      //                   username: v.obj.reportUser, //用户信息
      //                   papers: v.victimList[0].obj.idNo, //身份证号
      //                   phone: v.obj.reporterContact, //联系方式
      //                   sex: sex, //性别
      //                   time: constants.time(v.obj.incidentTs), //出险时间
      //                   plan: pt.phase, //进度
      //                   node: pt.node, //节点
      //                   isshow: isshow,
      //                   open: v.obj.caseSrc,
      //                   get_time: constants.time(v.obj.incidentTs),
      //                   op: '查看并操作',
      //                   insuranceUrl: v.victimList[0].obj.insurancePaper, //用户保险详情链接
      //                   w: v.obj.updateAt
			// 					});
			// 							nl--;
			// 							// if (nl == 0) {
			// 							// 	console.log('sortting!!');
			// 							// 	that.tableData.sort(sortcase);
			// 							// }
			// 						});
			// 				}
						
			// 				if (v.victimList[0].obj.insurancePolicyNo && v.victimList[0].obj.insurancePolicyNo != '') {
			// 					isshow = true;
			// 				} else {
			// 					isshow = false;
			// 				}
			// 				var pt = constants.pt2txt2(v.obj.caseState);
			// 				if (v.obj.caseState == 140 || v.obj.caseState == 150 || v.obj.caseState == 160) {
			// 					nl++;
			// 					getout(v.obj.caseState);
			// 				} else {
			// 					var address = '';
			// 					if (v.generalLocation) {
			// 						if (!constants.setTxt(v.generalLocation.addr, 'zh')) {
			// 							address = v.generalLocation.addr;
			// 						} else {
			// 							address = that.languageIndex == 0 ? constants.setTxt(v.generalLocation.addr, 'zh') : constants.setTxt(v.generalLocation.addr, 'en');
			// 						}
			// 					}

			// 					that.tableData.push({
			// 						state: v.obj.caseState,
			// 						caseId: v.obj.id,
      //             initialCaseId:v.obj.initialCaseId,
			// 						stateText3: v.obj.stateText3 || '无',
			// 						number: i + 1, //序号
			// 						casenumber: v.obj.caseNo, //案件编号
			// 						address, //地址
			// 						username: v.victimList[0].obj.victimName, //用户信息
			// 						papers: v.victimList[0].obj.idNo, //身份证号
      //             phone: v.obj.reporterContact, //联系方式
      //             sex: sex, //性别
      //             time: constants.time(v.obj.incidentTs), //出险时间
			// 						plan: pt.phase, //进度
			// 						node: pt.node, //节点
			// 						isshow: isshow,
			// 						open: v.obj.caseSrc,
			// 						get_time: constants.time(v.obj.incidentTs),
			// 						op: '查看并操作',
			// 						insuranceUrl: v.victimList[0].obj.insurancePaper, //用户保险详情链接
			// 						w: v.obj.updateAt,
      //              subRegulatorIdname:v.obj.subRegulatorId,
      //              insurancePolicyNo: v.victimList[0].obj.insurancePolicyNo,
      //              accidentType:v.obj.accidentType
			// 					});
			// 				}
      var that = this
               for(var i = 0; i<that.tableData.length; i++) {
                   for(var j = 0; j<that.companies1.length; j++) {
                     if(that.tableData[i].subRegulatorIdname == that.companies1[j].id) {
                       that.tableData[i].subRegulatorIdname = that.companies1[j].name
                     }
                   }
                }
			// 				that.caseId = v.obj.id;
            
			// 				that.obj.push(v.obj);
			// 				that.victimList.push(v.victimList[0]);
			// 			});
			// 		}
			// 	});
      var obj = {
        token:this.token,
        typeId:this.$route.query.typeId,
        start: 0,
        count: 1000,
        reportName:this.reportName, //报案人
        victimName:this.victimName, //出险人
        insurancePolicyNo:this.insurancePolicyNo, //保单号
        idNo:this.idNo //证件号 
      }
      
      caselist_case_info(obj).then((res)=>{
        console.log(res)
        for(var i = 0; i< res.data.obj.length; i++) {
          res.data.obj[i].addr = constants.setTxt(res.data.obj[i].addr, 'zh')
          //  : constants.setTxt(res.data.obj[i].addr, 'en');
           	if (res.data.obj[i].gender == '1') {
								res.data.obj[i].gender = '男';
							} else {
								res.data.obj[i].gender = '女';
							}
        }
       
       console.log(res.data.obj)
        	this.tableData = res.data.obj
      })
		
      },
      // getData() {
      //   var status='status=100';
      
      //   var data = {
      //     token: this.token,
      //     typeId: 800
      //   }
      //   xingshiGong(data,status)
      //     .then(res => {
      //       console.log(res);
      //       this.listSubUser()
      //       this.tableData=res.data.obj
      //     })
      //     .catch(err => {
      //       console.log(err);
      //     })
      // },
  closeCase(caseId){
    console.log(this.closeId)
        var data={
          token:this.token,
          caseId
        }
        closeOrdinaryCase(data)
        .then(res => {
          if(res.data.code == 0){
            this.$message.success('案件已关闭')
            this.getData()
          }
        })
        .catch(err => {
          console.log(err);
        })
      },
      listDomestic(id){
        var data={
          token:this.token,
          start:0,
          count:100,
          caseId:id
        }
        listDomestic(data)
        .then(res => {
          this.cooperaterDataList=res.data.obj;
          var cooperaterDataList=[]
          this.cooperaterDataList.forEach(item => {
            this.cooperaterData.forEach(item1 => {
              if(item1.id == item.id){
                cooperaterDataList.push(item1)
              }
            })

          })
          this.cooperaterDataList=cooperaterDataList
          this.toggleSelection(cooperaterDataList)

        })
        .catch(err => {
          console.log(err);
        })
        var data1={
          token:this.token,
          caseId:id
        }
        listNormalUser(data1)
        .then(res => {
          console.log(res);
          this.cooperaterData1=res.data.obj;
          setTimeout(() => {
            this.toggleSelection1(this.cooperaterData1)
          }, 500);

        })
        .catch(err => {
          console.log(err);
        })
      },

      diffDomestic(){
        var fids=''
        this.cooperaterDataListCheck.forEach((item,index) => {
             fids+='fids='+ item.id+'&'
        })
        var oids=''
        this.cooperaterDataList.forEach((item,index) => {
          if(index < this.cooperaterDataList.length - 1){
             oids+='oids='+ item.id+'&'
          }else{
             oids+='oids='+ item.id
          }
        })
        var data={
          token:this.token,
          caseId:this.caseId
        }
        diffDomestic(data,fids,oids)
        .then(res => {
          if(res.data.code == 0){
            this.showcooperaterDialogVisible=false;
            this.$message.success('添加成功')
            this.getData()
          }
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        })
      },
      diffNormalUser(){
        var fids=''
        this.ruserDataListCheck.forEach((item,index) => {
          if(index < this.ruserDataListCheck.length - 1){
             fids+='fids='+ item.id+'&'
          }else{
             fids+='fids='+ item.id
          }
        })
        var data={
          token:this.token,
          caseId:this.caseId
        }
        diffNormalUser(data,fids)
        .then(res => {
          if(res.data.code == 0){
            this.showcooperaterDialogVisible=false;
            this.$message.success('添加成功')
            this.getData()
          }
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        })
      },
      tores(obj){
        console.log(obj);
        this.caseId=obj.obj.id
        this.dialogFormVisible=true
        // this.totalFee=obj.obj.totalFee ;
        this.medicFee=obj.obj.medicFee || 0;
        this.otherFee=obj.obj.otherFee || 0;
        this.rescueFee=obj.obj.rescueFee || 0;
      },
      sureFun(){
        this.totalFee=Number(this.medicFee)+Number(this.otherFee)+Number(this.rescueFee)
        var data={
          token:this.token,
          id:this.caseId,
          totalFee:this.totalFee,
          medicFee:this.medicFee,
          otherFee:this.otherFee,
          rescueFee:this.rescueFee
        }
        getfinishSureCase(data)
        .then(res => {
          console.log(res);
          if(res.data.code == 0){
            this.$message.success('操作成功')
            this.getData();
            this.dialogFormVisible=false
          }
        })
        .catch(err => {
          console.log(err);
        })
      },
      toggleSelection(rows) {
        console.log(rows);
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      toggleSelection1(rows) {
        console.log(rows);
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable1.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable1.clearSelection();
        }
      },
      //创建大救星账户
      newDJXid() {
        if(this.victimName==''){
      		return this.$message.error("出险人姓名不能为空");
      	}else if(this.nationalMobile==''){
      		return this.$message.error("手机号不能为空")
      	}
        var data={
          token:this.token,
          name:this.victimName,
          nationalMobile:this.nationalMobile
        }
        creatBasic(data)
        .then(res => {
          console.log(res);
          if(res.data.code == 0){
            this.$message.success('创建成功')
            this.addContacterDialogVisible=false;
            this.cooperaterData1.push(res.data.obj)
            this.victimName='';
            this.nationalMobile='';
          }else{
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err);
        })
      },
      openWork(caseId) {
        joinCoord({token:this.token,caseId},'')
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        })
        this.$store.commit('caseIdFun', caseId);
        this.$store.commit('workBtnFun', true);
      }
    },
    mounted() {
      this.getData()
    
     
      console.log(this.$route.path)
    }
  };
</script>

<style scoped>
.popBox li{margin-bottom: 10px;}
.popBox .el-input{width: 300px;}
.contactAddStyle{position: absolute; top: 90px;right: 20px;cursor: pointer;z-index: 9;}
.contactAddStyle::before{
		content: '+';
		color: #00ABF9;
		width: 15px;
		height: 15px;
		display: inline-block;
		border-radius: 7.5px;
		text-align: center;
		line-height: 15px;
		font-size: 16px;
		margin-right: 5px;
		border: 1px solid #00ABF9;
	}

/* ========== 优化后的筛选区域样式 ========== */
.filter-container {
	background: #f8f9fa;
	border-radius: 8px;
	padding: 20px;
	margin-bottom: 20px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.filter-row {
	display: flex;
	flex-wrap: wrap;
	gap: 20px;
	margin-bottom: 20px;
	align-items: end;
}

.filter-item {
	display: flex;
	flex-direction: column;
	min-width: 200px;
	flex: 1;
}

.filter-label {
	font-size: 14px;
	color: #606266;
	margin-bottom: 8px;
	font-weight: 500;
}

.filter-input {
	width: 100%;
}

.button-row {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding-top: 10px;
	border-top: 1px solid #e4e7ed;
}

.button-group {
	display: flex;
	align-items: center;
	gap: 12px;
	flex-wrap: wrap;
}

.filter-btn {
	background: #409eff;
	border-color: #409eff;
	color: white;
	padding: 10px 20px;
	border-radius: 4px;
	transition: all 0.3s ease;
}

.filter-btn:hover {
	background: #66b1ff;
	border-color: #66b1ff;
}

.reset-btn {
	background: #909399;
	border-color: #909399;
	color: white;
	padding: 10px 20px;
	border-radius: 4px;
	transition: all 0.3s ease;
}

.reset-btn:hover {
	background: #a6a9ad;
	border-color: #a6a9ad;
}

/* 响应式设计 */
@media (max-width: 1200px) {
	.filter-row {
		gap: 15px;
	}
	
	.filter-item {
		min-width: 180px;
	}
}

@media (max-width: 768px) {
	.filter-container {
		padding: 15px;
	}
	
	.filter-row {
		flex-direction: column;
		gap: 15px;
	}
	
	.filter-item {
		min-width: auto;
		width: 100%;
	}
	
	.button-row {
		justify-content: center;
	}
	
	.button-group {
		flex-direction: column;
		width: 100%;
		gap: 10px;
	}
	
	.filter-btn,
	.reset-btn {
		width: 100%;
		max-width: 200px;
	}
}

@media (max-width: 480px) {
	.filter-container {
		padding: 10px;
		margin-bottom: 15px;
	}
	
	.filter-label {
		font-size: 13px;
	}
	
	.filter-btn,
	.reset-btn {
		font-size: 14px;
		padding: 8px 16px;
	}
}
/* ========== 优化后的筛选区域样式结束 ========== */
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/star/draftlist.vue